import apiClient from './client';

export interface GiornoCalendario {
  data: string;
  weekday: string;
  saturazione_pct: number;
  peso_programmato_kg: number;
  capacita_effettiva_kg: number;
  impianto_chiuso: boolean;
  ricezione_chiusa: boolean;
  lavorazione_chiusa: boolean;
  selezionabile_programmazione: boolean;
  note_chiusura: string | null;
}

export interface CapacitaCalendarioResponse {
  giorni: GiornoCalendario[];
}

export interface AreaDisponibile {
  area_id: string;
  codice: string;
  categoria: string;
  capacita_kg: number;
  capacita_libera_kg: number;
  capacita_dopo_programmazione_kg: number;
  saturazione_dopo_pct: number;
  warning: boolean;
  warning_msg: string | null;
  suggerita: boolean;
  cer_compatibile: boolean;
}

export interface AreeDisponibiliResponse {
  aree: AreaDisponibile[];
  suggerimento_area_id: string | null;
  cer_null_warning: boolean;
}

export async function getCapacitaCalendario(from: string, to: string): Promise<CapacitaCalendarioResponse> {
  const res = await apiClient.get('/api/programmazione/capacita-calendario', { params: { from, to } });
  return res.data;
}

export async function getAreeDisponibili(params: {
  data: string;
  ordine_id?: string;
  peso_kg?: number;
}): Promise<AreeDisponibiliResponse> {
  const res = await apiClient.get('/api/programmazione/aree-disponibili', { params });
  return res.data;
}
